import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import AppState from '@webapp/store//state';
import { LogoutUser } from '@webapp/store/auth/action-creators';
import { LOGOUT_USER } from '@webapp/store/auth/actions';
import { getAuthAttributes } from '@webapp/utils/auth/get-auth-attributes';
import { rudderTrack } from '@webapp/utils/rudderstack/init';

export const trackSignOutSuccess = (
  action$: Observable<LogoutUser>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType(LOGOUT_USER),
    withLatestFrom(state$),
    map(([_, state]) => {
      if (window.analytics) {
        const source = getAuthAttributes(state.auth.user);

        window.analytics.track('Signed Out', {
          id: source?.sub,
          email: source?.email,
          phone: source?.telephone,
        });

        rudderTrack('Signed Out', {
          id: source?.sub,
          email: source?.email,
          phone: source?.telephone,
        });
      }
    }),
    filter(() => false)
  );
